import fr from './fr.json';

export const locales = ({ fr } as unknown) as Record<
  'fr',
  Record<string, string>
>;
